import { render, staticRenderFns } from "./TasksMenu.vue?vue&type=template&id=2702fcf6&"
import script from "./TasksMenu.vue?vue&type=script&lang=js&"
export * from "./TasksMenu.vue?vue&type=script&lang=js&"
import style0 from "./TasksMenu.vue?vue&type=style&index=0&id=2702fcf6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports